import { render, staticRenderFns } from "./DeFragment.vue?vue&type=template&id=09b578e8&"
import script from "./DeFragment.vue?vue&type=script&lang=ts&"
export * from "./DeFragment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports